module.exports = __webpack_public_path__ + "img/BatAgriToitV.7da8c7d7.png";